export const ReviewError = {
  REVIEW_NOT_FOUND: 'REVIEW_NOT_FOUND',
};
